import Apps from '../containers/Apps/Apps';
import {APPS_TAB} from '../components/LeftNav/constants';

export const AppsRoutes = [
	{
		...Apps,
		path: '/apps',
		pathRegex: '/apps/:mainAppsTab?/:product?/:pdpTab?',
		tab: APPS_TAB,
		titleId: 'app.document.title.apps',
	},
];
